import { render, staticRenderFns } from "./App.vue?vue&type=template&id=4f2b95a2&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import IModal from '@/components/IModal'
import HdToast from '@/plugins/ui/Toast'
import HdDialog from '@/plugins/ui/Dialog'
component.options.components = Object.assign({IModal,HdToast,HdDialog}, component.options.components)
